import { type Context, useContext } from "react";

/**
 * Use this when you are sure the context value is defined.
 */
export default function useDefinedContextValue<T>(
  context: Context<T | undefined>,
): T {
  const value = useContext(context);
  if (value === undefined) {
    throw new Error(
      `Unexpected missing context value (missing provider in components tree?)`,
    );
  }
  return value;
}
